/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'
import { CardColorProps } from '../BaseIcon'

export const Mastercard: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='white' />
        <path d='M23.3427 6.49658H16.6582V17.5015H23.3427V6.49658Z' fill='#FF5F00' />
        <path
          d='M17.3476 11.9998C17.3468 10.9402 17.5851 9.89417 18.0445 8.94104C18.504 7.98791 19.1725 7.15261 19.9994 6.49834C18.9752 5.68697 17.7451 5.18242 16.4498 5.04237C15.1546 4.90231 13.8463 5.13241 12.6746 5.70635C11.503 6.28029 10.5151 7.17492 9.82398 8.288C9.13286 9.40108 8.76636 10.6877 8.76636 12.0008C8.76636 13.3139 9.13286 14.6005 9.82398 15.7136C10.5151 16.8267 11.503 17.7213 12.6746 18.2953C13.8463 18.8692 15.1546 19.0993 16.4498 18.9592C17.7451 18.8192 18.9752 18.3146 19.9994 17.5033C19.1722 16.8488 18.5035 16.0132 18.0441 15.0597C17.5847 14.1062 17.3465 13.0598 17.3476 11.9998Z'
          fill='#EB001B'
        />
        <path
          d='M30.5697 16.3371V16.1116H30.6661V16.0649H30.4366V16.1116H30.5273V16.3371H30.5697ZM31.0152 16.3371V16.0649H30.9458L30.8648 16.2593L30.7838 16.0649H30.7144V16.3371H30.7645V16.131L30.8397 16.3079H30.8918L30.967 16.131V16.3371H31.0152Z'
          fill='#F79E1B'
        />
        <path
          d='M31.2331 12.0001C31.2331 13.3133 30.8665 14.6 30.1753 15.7132C29.484 16.8263 28.496 17.7209 27.3242 18.2948C26.1524 18.8686 24.844 19.0986 23.5486 18.9583C22.2533 18.8181 21.0232 18.3133 19.999 17.5016C20.8257 16.8468 21.494 16.0112 21.9535 15.0581C22.4131 14.1049 22.6519 13.0589 22.6519 11.9992C22.6519 10.9394 22.4131 9.89346 21.9535 8.94027C21.494 7.98709 20.8257 7.15156 19.999 6.49671C21.0232 5.68508 22.2533 5.18029 23.5486 5.04003C24.844 4.89978 26.1524 5.12972 27.3242 5.70358C28.496 6.27745 29.484 7.17206 30.1753 8.28518C30.8665 9.3983 31.2331 10.685 31.2331 11.9982V12.0001Z'
          fill='#F79E1B'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38 1H2C1.44771 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H38C38.5523 23 39 22.5523 39 22V2C39 1.44772 38.5523 1 38 1ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H38C39.1046 24 40 23.1046 40 22V2C40 0.895431 39.1046 0 38 0H2Z'
          fill='#F0F0F0'
        />
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <g clipPath='url(#clip0_20400_5)'>
          <rect width='40' height='24' rx='2' fill='white' />
          <path d='M23.343 6.49658H16.6584V17.5015H23.343V6.49658Z' fill='black' />
          <path
            d='M17.3479 11.9998C17.347 10.9402 17.5853 9.89417 18.0448 8.94104C18.5042 7.98791 19.1727 7.15261 19.9997 6.49834C18.9754 5.68697 17.7454 5.18242 16.4501 5.04237C15.1548 4.90231 13.8466 5.13241 12.6749 5.70635C11.5032 6.28029 10.5153 7.17492 9.82422 8.288C9.13311 9.40108 8.7666 10.6877 8.7666 12.0008C8.7666 13.3139 9.13311 14.6005 9.82422 15.7136C10.5153 16.8267 11.5032 17.7213 12.6749 18.2953C13.8466 18.8692 15.1548 19.0993 16.4501 18.9592C17.7454 18.8192 18.9754 18.3146 19.9997 17.5033C19.1724 16.8488 18.5038 16.0132 18.0443 15.0597C17.5849 14.1062 17.3467 13.0598 17.3479 11.9998Z'
            fill='black'
            stroke='white'
            strokeWidth='0.5'
          />
          <path
            d='M30.57 16.3371V16.1116H30.6664V16.0649H30.4369V16.1116H30.5275V16.3371H30.57ZM31.0155 16.3371V16.0649H30.946L30.865 16.2593L30.784 16.0649H30.7146V16.3371H30.7648V16.131L30.84 16.3079H30.892L30.9673 16.131V16.3371H31.0155Z'
            fill='black'
          />
          <path
            d='M31.2334 12.0001C31.2333 13.3133 30.8667 14.6 30.1755 15.7132C29.4843 16.8263 28.4963 17.7209 27.3244 18.2948C26.1526 18.8686 24.8442 19.0986 23.5489 18.9583C22.2535 18.8181 21.0234 18.3133 19.9993 17.5016C20.8259 16.8468 21.4942 16.0112 21.9538 15.0581C22.4133 14.1049 22.6521 13.0589 22.6521 11.9992C22.6521 10.9394 22.4133 9.89346 21.9538 8.94027C21.4942 7.98709 20.8259 7.15156 19.9993 6.49671C21.0234 5.68508 22.2535 5.18029 23.5489 5.04003C24.8442 4.89978 26.1526 5.12972 27.3244 5.70358C28.4963 6.27745 29.4843 7.17206 30.1755 8.28518C30.8667 9.3983 31.2333 10.685 31.2334 11.9982V12.0001Z'
            fill='black'
            stroke='white'
            strokeWidth='0.5'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2C1.44771 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H38C38.5523 23 39 22.5523 39 22V2C39 1.44772 38.5523 1 38 1ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H38C39.1046 24 40 23.1046 40 22V2C40 0.895431 39.1046 0 38 0H2Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_20400_5'>
            <rect width='40' height='24' rx='2' fill='white' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
